<div class="document-library-container" [ngStyle]="{'height': scrHeight, 'overflow': 'auto'}">

  <div class="document-shell">
    <div class="document-shell-header">
      <div>
        <h1 class="library-title">Manage Documents</h1>
        <p class="library-subtitle">View and manage all documents grouped by collection.</p>
      </div>
      <div class="header-action">
        <button class="upload-btn" (click)="openUploadModal()">
          <mat-icon>add</mat-icon>
          <span>Add Document</span>
        </button>
      </div>
    </div>

    <div class="stats-grid">
      <div class="stat-panel">
        <div class="stat-icon red-tile">
          <mat-icon>folder_open</mat-icon>
        </div>
        <div>
          <div class="stat-number">{{ totalCollections }}</div>
          <div class="stat-title">Collections</div>
        </div>
      </div>

      <div class="stat-panel">
        <div class="stat-icon blue-tile">
          <mat-icon>description</mat-icon>
        </div>
        <div>
          <div class="stat-number">{{ totalDocuments }}</div>
          <div class="stat-title">Active Documents</div>
        </div>
      </div>

      <div class="stat-panel">
        <div class="stat-icon amber-tile">
          <mat-icon>archive</mat-icon>
        </div>
        <div>
          <div class="stat-number">{{ totalArchivedDocuments }}</div>
          <div class="stat-title">Archived Documents</div>
        </div>
      </div>

      
    </div>

    <div class="toolbar-row">
      <div class="list-toggle-group">
        <button type="button" class="list-toggle" [class.active]="!showArchived" (click)="setArchivedView(false)">
          <span>Active List</span>
          <span class="toggle-badge">{{ filteredCollections().length }}</span>
        </button>
        <button type="button" class="list-toggle" [class.active]="showArchived" (click)="setArchivedView(true)">
          <span>Archived List</span>
          <span class="toggle-badge">{{ filteredArchivedCollections().length }}</span>
        </button>
      </div>

      <div class="search-container toolbar-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          class="search-input"
          [placeholder]="showArchived ? 'Search archived documents...' : 'Search documents...'"
          [(ngModel)]="searchQuery"
        />
      </div>
    </div>
  </div>

  <!-- Global loading -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading collections...</p>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && !showArchived && filteredCollections().length === 0" class="no-documents">
    <mat-icon class="no-docs-icon">folder_off</mat-icon>
    <h3>No Documents Found</h3>
    <p>Collections without documents are hidden from the list below.</p>
  </div>

  <div *ngIf="!isLoading && showArchived && filteredArchivedCollections().length === 0" class="no-documents">
    <mat-icon class="no-docs-icon">archive</mat-icon>
    <h3>No Archived Documents</h3>
    <p>Archived documents will appear here once items are archived.</p>
  </div>

  <!-- Collection accordion list -->
  <div *ngIf="!isLoading && !showArchived" class="collections-list">
    <div *ngFor="let col of filteredCollections()" class="collection-card">

      <div class="collection-card-header" (click)="toggleExpand(col)">
        <div class="collection-header-left">
          <mat-icon class="expand-icon-static" [class.expanded]="col.isExpanded">expand_more</mat-icon>
          <div class="collection-title-block">
            <div class="collection-title-row">
              <span class="collection-name">{{ col.name }}</span>
              <span class="status-badge success-badge">{{ col.documents.length }} Active</span>
            </div>
            <div class="collection-meta">Updated {{ getLatestDate(col.documents)| date:'MM/dd/yyyy hh:mm a' }}</div>
          </div>
        </div>
      </div>

      <div class="collection-card-body" *ngIf="col.isExpanded">
        <table class="documents-table">
          <thead>
            <tr>
              <th class="col-name">File Name</th>
              <th class="col-owner">Uploaded By</th>
              <th class="col-date">Date Modified</th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of col.documents">
              <td class="col-name">
                <div class="file-info">
                  <div class="file-icon-container">
                    <ng-container [ngSwitch]="iconType(doc.name)">
                      <svg *ngSwitchCase="'pdf'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'xls'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'doc'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'image'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                        <circle cx="9" cy="9" r="2"/>
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                      </svg>
                      <mat-icon *ngSwitchCase="'csv'" [style.color]="'#10b981'" class="mat-icon-file">table_chart</mat-icon>
                      <svg *ngSwitchDefault width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                      </svg>
                    </ng-container>
                  </div>
                  <span class="file-name">{{ doc.name }}</span>
                </div>
              </td>
              <td class="col-owner">{{ doc.uploadedBy }}</td>
              <td class="col-date">{{ doc.dateModified | date:'MM/dd/yyyy hh:mm a' }}</td>
              <td class="col-actions">
                <div class="row-action-group">
                  <button class="row-action-btn view-action-btn" (click)="viewDocument(doc); $event.stopPropagation()" title="View document">
                    <mat-icon>visibility</mat-icon>
                    <span>View</span>
                  </button>
                  <button class="row-action-btn archive-action-btn" (click)="confirmDelete(doc, col); $event.stopPropagation()" title="Archive document">
                    <mat-icon>archive</mat-icon>
                    <span>Archive</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && showArchived" class="collections-list">
    <div *ngFor="let col of filteredArchivedCollections()" class="collection-card archived-card">
      <div class="collection-card-header" (click)="toggleExpand(col)">
        <div class="collection-header-left">
          <mat-icon class="expand-icon-static" [class.expanded]="col.isExpanded">expand_more</mat-icon>
          <div class="collection-title-block">
            <div class="collection-title-row">
              <span class="collection-name">{{ col.name }}</span>
              <span class="status-badge archived-badge">{{ col.archivedDocuments.length }} Archived</span>
            </div>
            <div class="collection-meta">Archived items for this collection</div>
          </div>
        </div>
      </div>

      <div class="collection-card-body" *ngIf="col.isExpanded">
        <table class="documents-table">
          <thead>
            <tr>
              <th class="col-name">File Name</th>
              <th class="col-owner">Uploaded By</th>
              <th class="col-date">Archived Date</th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of col.archivedDocuments">
              <td class="col-name">
                <div class="file-info">
                  <div class="file-icon-container">
                    <ng-container [ngSwitch]="iconType(doc.name)">
                      <svg *ngSwitchCase="'pdf'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'xls'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'doc'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>
                      </svg>
                      <svg *ngSwitchCase="'image'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                        <circle cx="9" cy="9" r="2"/>
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                      </svg>
                      <mat-icon *ngSwitchCase="'csv'" [style.color]="'#10b981'" class="mat-icon-file">table_chart</mat-icon>
                      <svg *ngSwitchDefault width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                      </svg>
                    </ng-container>
                  </div>
                  <span class="file-name">{{ doc.name }}</span>
                </div>
              </td>
              <td class="col-owner">{{ doc.uploadedBy }}</td>
              <td class="col-date">{{ doc.dateModified | date:'MM/dd/yyyy hh:mm a' }}</td>
              <td class="col-actions">
                <div class="row-action-group">
                  <button class="row-action-btn view-action-btn" (click)="viewDocument(doc); $event.stopPropagation()" title="View document">
                    <mat-icon>visibility</mat-icon>
                    <span>View</span>
                  </button>
                  <button class="row-action-btn restore-action-btn" (click)="restoreDocument(doc, col); $event.stopPropagation()" title="Restore document">
                    <mat-icon>restore</mat-icon>
                    <span>Restore</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>

<app-tutorial-video-widget
  screenId="manage-documents"
  title="Manage Documents walkthrough"
  teaserDescription="Watch a quick walkthrough of this screen."
  storageKey="manage-documents-tutorial-seen"
  teaserPosition="bottom-right"
  launcherPosition="bottom-right"
  [allowLauncherDismiss]="true">
</app-tutorial-video-widget>

<!-- Upload Modal -->
<div class="modal-backdrop" *ngIf="showUploadModal" (click)="closeUploadModal()"></div>
<div class="upload-modal" *ngIf="showUploadModal">
  <div class="upload-modal-header">
    <h3>Add Document</h3>
  [autoPlaySequence]="adminTutorialSequence"
    <button class="modal-close-btn" (click)="closeUploadModal()" title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="upload-form-row">
    <label class="upload-label">Collection Name</label>
    <select class="upload-select" [(ngModel)]="selectedUploadCollectionId">
      <option value="">Select collection</option>
      <option *ngFor="let col of uploadCollections" [value]="col.id">{{ col.name }}</option>
    </select>
  </div>

  <div class="upload-form-row">
    <label class="upload-label">Documents</label>
    <input
      #uploadFileInput
      type="file"
      multiple
      hidden
      accept=".pdf,.doc,.docx,.xls,.xlsx,.xlsm,.csv,.png,.jpg,.jpeg"
      (change)="onUploadFileSelected($event, uploadFileInput)"
    />
    <div class="upload-file-row">
      <button class="upload-file-btn" (click)="uploadFileInput.click()">
        <mat-icon>add</mat-icon>
        <span>Choose Files</span>
      </button>
      <span class="upload-file-count" *ngIf="selectedUploadFiles.length > 0">
        {{ selectedUploadFiles.length }} file(s) selected
      </span>
    </div>
    
    <!-- List of selected files -->
    <div class="upload-file-list" *ngIf="selectedUploadFiles.length > 0">
      <div class="file-list-header">
        <span class="file-list-title">Selected Files</span>
        <button class="clear-all-btn" type="button" (click)="clearAllFiles()" title="Clear all">Clear all</button>
      </div>
      <div class="file-item" *ngFor="let file of selectedUploadFiles; let i = index">
        <div class="file-item-info">
          <mat-icon class="file-item-icon">{{ getFileIcon(file.name) }}</mat-icon>
          <div class="file-item-details">
            <div class="file-item-name">{{ file.name }}</div>
            <div class="file-item-size">{{ formatFileSize(file.size) }}</div>
          </div>
        </div>
        <button class="file-item-remove" type="button" (click)="removeFile(i)" title="Remove">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="upload-modal-actions">
    <button class="btn-cancel" (click)="closeUploadModal()">Cancel</button>
    <button class="btn-delete" [disabled]="isSubmittingUpload" (click)="submitUpload(uploadFileInput)">
      {{ isSubmittingUpload ? 'Uploading...' : 'Upload' }}
    </button>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-backdrop" *ngIf="showDeleteConfirm" (click)="cancelDelete()"></div>
<div class="confirm-modal" *ngIf="showDeleteConfirm">
  <div class="confirm-modal-header">
    <mat-icon class="confirm-icon">warning_amber</mat-icon>
    <h3>Archive Document</h3>
  </div>
  <p class="confirm-message">
    Are you sure you want to archive <strong>{{ pendingDeleteDoc?.name }}</strong>?
    This document will be removed from the active list.
  </p>
  <div class="confirm-actions">
    <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
    <button class="btn-delete" (click)="executeDelete()">Archive</button>
  </div>
</div>

<!-- Document Preview Overlay -->
<div class="position-fixed top-0 start-0 end-0 bottom-0 d-flex flex-column preview-overlay" *ngIf="isPreviewOpen">
  <div class="bg-white p-2 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <h6 class="mb-0 text-dark-primary">{{ previewTitle }}</h6>
    </div>
    <div class="d-flex align-items-center gap-3">
      <div *ngIf="previewType === 'xls'" class="d-flex align-items-center gap-2">
        <label class="small text-secondary me-1">Sheet</label>
        <select class="form-select form-select-sm" style="width:auto" [(ngModel)]="selectedSheetIndex"
          (change)="renderSheetByIndex(selectedSheetIndex)">
          <option *ngFor="let s of sheetNames; let i = index" [ngValue]="i">{{ s }}</option>
        </select>
      </div>
      <button
        class="btn btn-light border-0 rounded-2 d-inline-flex align-items-center justify-content-center preview-close-btn"
        (click)="closePreview()" aria-label="Close preview">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.4"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <div class="bg-white flex-grow-1 overflow-auto p-2">
    <iframe *ngIf="previewType === 'pdf'" [src]="previewUrl" width="100%" height="100%"></iframe>
    <img *ngIf="previewType === 'image'" [src]="previewUrl" alt="Image preview" class="preview-image" />
    <div *ngIf="previewType === 'docx'" #docxContainer class="h-100 overflow-auto"></div>
    <div *ngIf="previewType === 'xls'" [innerHTML]="excelHtml"></div>
    <p *ngIf="previewType === 'unsupported'" class="text-center text-secondary">Preview not supported for this file type.</p>
  </div>
</div>

